import React, { useEffect, useState } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { Card, CardContent, Typography, AppBar, Tabs, Tab } from '@mui/material';
import CustomButton from '../Common/Button';
import { GetQuestion } from '../../utils/axios/questionAPI';
import { GetResults } from '../../utils/axios/adminAPI';

const AdminDashboard = () => {
  const [rows, setRows] = useState([]);
  const [results, setResults] = useState([]);
  const [tabValue, setTabValue] = useState(0);

  const handleSend = () => {
    setRows([]);
  };

  const handleChange = (_event, newValue) => {
    setTabValue(newValue);
    if (newValue === 1) {
      getResults();
    }
  };

  const columns = [
    { field: 'QuestionId', headerName: 'QuestionId', width: 200 },
    { field: 'Question', headerName: 'Question', width: 500 },
    {
      field: 'Options', headerName: 'OptionA', width: 200,
      valueGetter: (value) => (value.row.Options.split(',')[0])
    },
    {
      field: 'OptionsB', headerName: 'OptionB', width: 200,
      valueGetter: (value) => (value.row.Options.split(',')[1])
    },
    {
      field: 'Option C', headerName: 'OptionC', width: 200,
      valueGetter: (value) => (value.row.Options.split(',')[2])
    },
    {
      field: 'Option D', headerName: 'OptionD', width: 200,
      valueGetter: (value) => (value.row.Options.split(',')[3])
    },
  ];

  const resultColumns = [
    { field: 'CollegeName', headerName: 'College', width: 200 },
    { field: 'UserId', headerName: 'User ID', width: 100 },
    { field: 'UserName', headerName: 'Name', width: 200 },
    { field: 'UserEmail', headerName: 'Email', width: 200 },
    { field: 'OutOf', headerName: 'Total Marks', width: 100 },
    { field: 'Marks', headerName: 'Marks Scored', width: 100 }
  ];

  const getQuestions = async () => {
    let questionsPayload = {
      CategoryId: 2,
    }
    let questionResponse = await GetQuestion(questionsPayload);
    let split = questionResponse.data.map(item => item.Options.split(','));
    setRows(questionResponse.data.map((row, index) => ({ id: index, ...row })));
  }

  const getResults = async () => {
    let resultResponse = await GetResults();

    setResults(resultResponse.data.map((row, index) => ({ id: index, ...row })));
  }

  useEffect(() => {
    getQuestions();
  }, []);
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', margin: '0', height: '100vh', width: '100vw', background: 'white' }}>
      <AppBar position="static" style={{ background: "white", width: '100%' }}>
        <Tabs
          value={tabValue}
          onChange={handleChange}
          indicatorColor="primary"
          textColor="primary"
          style={{ width: '100%' }}
        >
          <Tab label="Dashboard" style={{ color: 'black' }} />
          <Tab label="Results" style={{ color: 'black' }} />
        </Tabs>
      </AppBar>
      {tabValue === 0 && (
        <Card style={{ display: 'flex', flexDirection: 'column', flexGrow: 1, width: '100%', overflow: 'auto', margin: '10px', backgroundColor: '#F5F5F5' }}>
          <CardContent style={{ display: 'flex', flexDirection: 'column', flexGrow: 1 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
              <Typography variant="h5">Admin Dashboard</Typography>
            </div>
            <div style={{ height: 'calc(100% - 100px)', width: '100%', border: '1px solid black' }}>
              <DataGrid
                rows={rows}
                columns={columns}
                pageSize={5}
                rowHeight={40}
                disableSelectionOnClick
              />
            </div>
          </CardContent>
        </Card>
      )}
      {tabValue === 1 && (
        <Card style={{ display: 'flex', flexDirection: 'column', flexGrow: 1, width: '100%', overflow: 'auto', margin: '10px', backgroundColor: '#F5F5F5' }}>
          <CardContent style={{ flexGrow: 1 }}>
            <Typography variant="h5" style={{ marginBottom: '20px' }}>Results</Typography>
            <div style={{ height: 'calc(100% - 100px)', width: '100%', border: '1px solid black' }}> {/* Added border here */}
              <DataGrid
                rows={results}
                columns={resultColumns}
                pageSize={5}
                rowHeight={40}
                disableSelectionOnClick
              />
            </div>
          </CardContent>
        </Card>
      )}
    </div>
  );
}

export default AdminDashboard;
